// Global
import { tv } from 'tailwind-variants';
import { JSX } from 'react';

// Lib
import { ComponentProps } from 'lib/component-props';
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';

export const Default = (props: ComponentProps): JSX.Element => {
  const { RenderingIdentifier } = props?.params || {};
  const { base } = TAILWIND_VARIANTS();

  return (
    <div
      className={base()}
      data-component="authorable/shared/site-structure/main-layout/mainlayout"
      id={RenderingIdentifier}
    >
      <PlaceholderWrapper name="headless-main-content" rendering={props.rendering} />
    </div>
  );
};

const TAILWIND_VARIANTS = tv({
  slots: {
    base: [
      // 'gap-6',
      'grid',
      'grid-cols-1',
      //'m-auto',
      //'max-w-screen-xxl',
      'w-full',
      // 'mdlg:gap-11.5',
      //'lg:px-20 px-10',
    ],
  },
});
